var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0-27.125a15.5,15.5,0,0,0-15.5,15.5A15.5,15.5,0,0,0,0,3.875a15.5,15.5,0,0,0,15.5-15.5A15.5,15.5,0,0,0,0-27.125ZM7.011-14.3l-7.75,7.75a1.682,1.682,0,0,1-1.2.5,1.687,1.687,0,0,1-1.2-.5l-3.875-3.875a1.7,1.7,0,0,1,0-2.4,1.7,1.7,0,0,1,2.4,0l2.675,2.677L4.614-16.7a1.7,1.7,0,0,1,2.4,0A1.7,1.7,0,0,1,7.011-14.3Z",
    transform: "translate(15.5 27.125)",
    fill: "#448444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreenIcon);
export default __webpack_public_path__ + "static/media/checked-green-icon.849cbb783f5f16ca536a4c562af52bc0.svg";
export { ForwardRef as ReactComponent };